const orderSort ={
    'before': [ // 입금전
        {label:'주문일순', value:'order_date-asc'},
        {label:'주문일역순', value:'order_date-desc'},
        {label:'입금액순', value:'o_price-asc'},
        {label:'입금액역순', value:'o_price-desc'},
    ],
    'complete':[ // 배송완료
        {label:'주문일순', value:'order_date-asc'},
        {label:'주문일역순', value:'order_date-desc'},
        {label:'결제일순', value:'o.created_at-asc'},
        {label:'결제일역순', value:'o.created_at-desc'},
        {label:'결제액순', value:'c_price-asc'},
        {label:'결제액역순', value:'c_price-desc'},
    ],
    'itemReady':[ // 배송완료
        {label:'주문일순', value:'order_date-asc'},
        {label:'주문일역순', value:'order_date-desc'},
        {label:'결제일순', value:'o.created_at-asc'},
        {label:'결제일역순', value:'o.created_at-desc'},
        {label:'결제액순', value:'c_price-asc'},
        {label:'결제액역순', value:'c_price-desc'},
    ],
    'preparing' :[ // 배송준비중
        {label:'주문일순', value:'order_date-asc'},
        {label:'주문일역순', value:'order_date-desc'},
        {label:'결제일순', value:'o.created_at-asc'},
        {label:'결제일역순', value:'o.created_at-desc'},
        {label:'결제액순', value:'c_price-asc'},
        {label:'결제액역순', value:'c_price-desc'},
    ],
    'shipping':[ // 배송중
        {label:'주문일순', value:'order_date-asc'},
        {label:'주문일역순', value:'order_date-desc'},
        {label:'결제일순', value:'o.created_at-asc'},
        {label:'결제일역순', value:'o.created_at-desc'},
        {label:'결제액순', value:'c_price-asc'},
        {label:'결제액역순', value:'c_price-desc'},
    ],
    'shippingDone' :[ // 배송완료
        {label:'주문일순', value:'order_date-asc'},
        {label:'주문일역순', value:'order_date-desc'},
        {label:'결제일순', value:'o.created_at-asc'},
        {label:'결제일역순', value:'o.created_at-desc'},
        {label:'결제액순', value:'c_price-asc'},
        {label:'결제액역순', value:'c_price-desc'},
        {label:'배송일순', value:'ce_invoice_time-asc'},
        {label:'배송일역순', value:'ce_invoice_time-desc'},
        {label:'배송완료일순', value:'ce_invoice_end_time-asc'},
        {label:'배송완료일역순', value:'ce_invoice_end_time-desc'},
    ],
    cancel : [ // 취소 관리
        {label:'주문일순', value:'o.created_at-asc'},
        {label:'주문일역순', value:'o.created_at-desc'},
        {label:'주문취소요청일순', value:'cc.created_at-asc'},
        {label:'주문취소요청일역순', value:'cc.created_at-desc'},
        {label:'주문취소일순', value:'cc_canceled_at-asc'},
        {label:'주문취소일역순', value:'cc_canceled_at-desc'},
        {label:'결제액순', value:'c_price-asc'},
        {label:'결제액역순', value:'c_price-desc'},
    ],
    exchange: [ // 교환관리
        {label:'주문일순', value:'o.created_at-asc'},
        {label:'주문일역순', value:'o.created_at-desc'},
        {label:'교환요청일순', value:'ct.created_at-asc'},
        {label:'교환요청일역순', value:'ct.created_at-desc'},
        {label:'교환요청승인일순', value:'ct_accept_at-asc'},
        {label:'교환요청승인일역순', value:'ct_accept_at-desc'},
        {label:'교환요청거절일순', value:'ct_deny_at-asc'},
        {label:'교환요청거절일역순', value:'ct_deny_at-desc'},
        {label:'교환완료일순', value:'ct_done_at-asc'},
        {label:'교환완료일역순', value:'ct_done_at-desc'},
        {label:'결제액순', value:'c_price-asc'},
        {label:'결제액역순', value:'c_price-desc'},
    ],
    refund : [
        {label:'주문일순', value:'o.created_at-asc'},
        {label:'주문일역순', value:'o.created_at-desc'},
        {label:'환불요청일순', value:'cr.created_at-asc'},
        {label:'환불요청일역순', value:'cr.created_at-desc'},
        {label:'환불요청승인일순', value:'cr_accept_at-asc'},
        {label:'환불요청승인일역순', value:'cr_accept_at-desc'},
        {label:'환불요청거절일순', value:'cr_deny_at-asc'},
        {label:'환불요청거절일역순', value:'cr_deny_at-desc'},
        {label:'환불완료일순', value:'cr_done_at-asc'},
        {label:'환불완료일역순', value:'cr_done_at-desc'},
        {label:'결제액순', value:'c_price-asc'},
        {label:'결제액역순', value:'c_price-desc'},
    ],
    'memberOrderHistory':[ // 회원 구매기록
        {label:'주문일순', value:'order_date-asc'},
        {label:'주문일역순', value:'order_date-desc'},
        {label:'결제일순', value:'o.created_at-asc'},
        {label:'결제일역순', value:'o.created_at-desc'},
        {label:'결제액순', value:'o_price-asc'},
        {label:'결제액역순', value:'o_price-desc'},
    ],
    'brandOrderHistory':[ // 브랜드 구매기록
        {label:'주문일순', value:'order_date-asc'},
        {label:'주문일역순', value:'order_date-desc'},
        {label:'결제일순', value:'o.created_at-asc'},
        {label:'결제일역순', value:'o.created_at-desc'},
        {label:'결제액순', value:'o_price-asc'},
        {label:'결제액역순', value:'o_price-desc'},
    ],
}

export default {
    methods: {
        returnOrderSort(type) {
            return orderSort[type];
        },
    },
}
